export const idlFactory = ({ IDL }) => {
  const ProjectEventMonthDataId__1 = IDL.Nat64;
  const Range = IDL.Record({ 'start' : IDL.Nat32, 'length' : IDL.Nat32 });
  const ClientId = IDL.Nat32;
  const MonthActivityIndexData = IDL.Nat32;
  const BackupApiError = IDL.Variant({
    'unauthorisedAccess' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const BackupResultProjectClientEventMonthActivityIndex = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(ClientId, MonthActivityIndexData)),
    'err' : BackupApiError,
  });
  const ProjectId__1 = IDL.Nat32;
  const ProjectStatsDataId__1 = IDL.Nat64;
  const BackupResultProjectClientMonthActivityIndex = IDL.Variant({
    'ok' : IDL.Vec(
      IDL.Tuple(
        ProjectStatsDataId__1,
        IDL.Vec(IDL.Tuple(ClientId, MonthActivityIndexData)),
      )
    ),
    'err' : BackupApiError,
  });
  const ClientProfileId = IDL.Nat64;
  const ClientProfile = IDL.Record({ 'createDateTime' : IDL.Int });
  const BackupResultProjectClientProfiles = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(ClientProfileId, ClientProfile)),
    'err' : BackupApiError,
  });
  const ProjectId__2 = IDL.Nat32;
  const BackupResultProjects = IDL.Variant({
    'ok' : IDL.Vec(ProjectId__2),
    'err' : BackupApiError,
  });
  const BackupResultProjectMonthCounters = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(ProjectStatsDataId__1, IDL.Vec(IDL.Nat))),
    'err' : BackupApiError,
  });
  const ProjectStatsDataId = IDL.Nat64;
  const BackupResultProjectMonthRegistration = IDL.Variant({
    'ok' : IDL.Vec(IDL.Vec(IDL.Nat64)),
    'err' : BackupApiError,
  });
  const ProjectEventMonthDataId = IDL.Nat64;
  const BackupResultProjectMonthUniques = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(ProjectEventMonthDataId, IDL.Vec(IDL.Nat32))),
    'err' : BackupApiError,
  });
  const ProjectClientEventMonthActivityIndex = IDL.Record({
    'monthActivityIndexData' : MonthActivityIndexData,
    'clientId' : ClientId,
  });
  const BackupRestoreResult = IDL.Variant({
    'ok' : IDL.Bool,
    'err' : BackupApiError,
  });
  const ProjectClientMonthActivityIndex = IDL.Record({
    'projectClientEventMonthActivityIndexArray' : IDL.Vec(
      ProjectClientEventMonthActivityIndex
    ),
    'projectStatsDataId' : ProjectStatsDataId__1,
  });
  const ProjectClientProfiles = IDL.Record({
    'createDateTime' : IDL.Int,
    'clientProfileId' : ClientProfileId,
  });
  const ProjectMonthCounters = IDL.Record({
    'monthCountersData' : IDL.Vec(IDL.Nat),
    'projectStatsDataId' : ProjectStatsDataId__1,
  });
  const MonthRegistration = IDL.Record({
    'registrations' : IDL.Vec(IDL.Nat64),
  });
  const ProjectMonthRegistration = IDL.Record({
    'monthRegistrationData' : IDL.Vec(MonthRegistration),
  });
  const ProjectMonthUniques = IDL.Record({
    'monthUniquesData' : IDL.Vec(IDL.Nat32),
    'projectEventMonthDataId' : ProjectEventMonthDataId,
  });
  const SdkVersion = IDL.Nat32;
  const AccessToken = IDL.Text;
  const AnalyticsReceiverApiError = IDL.Variant({
    'invalidClient' : IDL.Null,
    'wrongAccessToken' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const CollectResult = IDL.Variant({
    'ok' : IDL.Null,
    'err' : AnalyticsReceiverApiError,
  });
  const Event = IDL.Record({
    'name' : IDL.Text,
    'sequence' : IDL.Int,
    'timeMillis' : IDL.Int,
  });
  const Session = IDL.Record({ 'sequence' : IDL.Int, 'timeMillis' : IDL.Int });
  const PacketItem = IDL.Variant({ 'event' : Event, 'session' : Session });
  const Packet = IDL.Record({ 'items' : IDL.Vec(PacketItem) });
  const CollectPacketResultOk = IDL.Record({});
  const CollectPacketResultError = IDL.Variant({
    'api' : AnalyticsReceiverApiError,
  });
  const CollectPacketResult = IDL.Variant({
    'ok' : CollectPacketResultOk,
    'err' : CollectPacketResultError,
  });
  const ProjectId = IDL.Nat32;
  const EventId = IDL.Nat32;
  const ResultApiError = IDL.Variant({
    'unauthorisedAccess' : IDL.Null,
    'error' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const ResultApiAddProjectEventName = IDL.Variant({
    'ok' : IDL.Tuple(
      IDL.Bool,
      IDL.Opt(EventId),
      IDL.Vec(IDL.Tuple(EventId, IDL.Text)),
    ),
    'err' : ResultApiError,
  });
  const AddProjectEventName = IDL.Func(
      [ProjectId, IDL.Text],
      [ResultApiAddProjectEventName],
      [],
    );
  const ResultApiGetProjectEvents = IDL.Variant({
    'ok' : IDL.Vec(IDL.Tuple(EventId, IDL.Text)),
    'err' : ResultApiError,
  });
  const GetProjectEvents = IDL.Func(
      [ProjectId],
      [ResultApiGetProjectEvents],
      [],
    );
  const EventRegistryFactory = IDL.Record({
    'addProjectEventName' : AddProjectEventName,
    'getProjectEvents' : GetProjectEvents,
  });
  const AnalyticsStoreConfigurationRequest = IDL.Variant({
    'setEventRegistryFactory' : EventRegistryFactory,
  });
  const Result = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const IsCollectRequiredResult = IDL.Variant({
    'ok' : IDL.Bool,
    'err' : AnalyticsReceiverApiError,
  });
  const IsCollectRequired = IDL.Func(
      [IDL.Opt(IDL.Principal), SdkVersion, AccessToken],
      [IsCollectRequiredResult],
      ['query'],
    );
  const PacketRejectedItem = IDL.Record({ 'sequence' : IDL.Int });
  const ValidatePacketResultOk = IDL.Record({
    'rejectedItems' : IDL.Opt(IDL.Vec(PacketRejectedItem)),
  });
  const ValidatePacketResultError = IDL.Variant({
    'api' : AnalyticsReceiverApiError,
  });
  const ValidatePacketResult = IDL.Variant({
    'ok' : ValidatePacketResultOk,
    'err' : ValidatePacketResultError,
  });
  const ValidatePacket = IDL.Func(
      [IDL.Opt(IDL.Principal), SdkVersion, AccessToken, Packet],
      [ValidatePacketResult],
      ['query'],
    );
  const CollectPacket = IDL.Func(
      [IDL.Opt(IDL.Principal), SdkVersion, AccessToken, Packet],
      [CollectPacketResult],
      [],
    );
  const Collect = IDL.Func(
      [IDL.Opt(IDL.Principal), SdkVersion, AccessToken],
      [CollectResult],
      [],
    );
  const AnalyticsReceiverApi = IDL.Record({
    'isCollectRequired' : IsCollectRequired,
    'validatePacket' : ValidatePacket,
    'collectPacket' : CollectPacket,
    'collect' : Collect,
  });
  const GetAnalyticsReceiverApiResult = IDL.Variant({
    'ok' : AnalyticsReceiverApi,
    'err' : AnalyticsReceiverApiError,
  });
  const GetAnalyticsReceiverApi = IDL.Func(
      [IDL.Opt(IDL.Principal), SdkVersion, AccessToken],
      [GetAnalyticsReceiverApiResult],
      ['query'],
    );
  const RegisterNewClientResult = IDL.Variant({
    'ok' : IDL.Null,
    'err' : AnalyticsReceiverApiError,
  });
  const RegisterNewClient = IDL.Func(
      [AccessToken],
      [RegisterNewClientResult],
      [],
    );
  const AnalyticsReceiverFactory = IDL.Record({
    'getAnalyticsReceiverApi' : GetAnalyticsReceiverApi,
    'registerNewClient' : RegisterNewClient,
  });
  const AccessToken__1 = IDL.Text;
  const LifecycleChartRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const ChartLastNIntervalData = IDL.Record({
    'data' : IDL.Vec(IDL.Int32),
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const ProjectDashboardResultData = IDL.Record({
    'dau' : ChartLastNIntervalData,
    'mau' : ChartLastNIntervalData,
    'wau' : ChartLastNIntervalData,
    'projectUsers' : IDL.Int32,
    'newUsers' : ChartLastNIntervalData,
  });
  const AnalyticsReducerApiError = IDL.Variant({
    'wrongApiKey' : IDL.Null,
    'notFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const GetProjectDashboardResult = IDL.Variant({
    'ok' : ProjectDashboardResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectDashboardChunk = IDL.Func(
      [AccessToken__1, LifecycleChartRequestChunkParams],
      [GetProjectDashboardResult],
      ['query'],
    );
  const EventDescription = IDL.Record({ 'name' : IDL.Text });
  const EventQuery = IDL.Record({ 'eventDescription' : EventDescription });
  const QueryPeriod = IDL.Variant({ 'last' : IDL.Nat32 });
  const QueryPartitionRange = IDL.Record({
    'start' : IDL.Nat32,
    'length' : IDL.Nat32,
  });
  const EventUniquesChartResultData = IDL.Record({
    'uniques' : ChartLastNIntervalData,
  });
  const GetProjectEventUniquesResult = IDL.Variant({
    'ok' : EventUniquesChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectEventUniquesMonth = IDL.Func(
      [AccessToken__1, EventQuery, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const QueryEventVariant = IDL.Variant({
    'event' : EventQuery,
    'session' : IDL.Null,
    'anyEvent' : IDL.Null,
    'newUser' : IDL.Null,
  });
  const PeriodType = IDL.Variant({ 'last' : IDL.Nat32 });
  const EventUniquesGranularity = IDL.Variant({
    'monthly' : IDL.Null,
    'daily' : IDL.Null,
    'weekly' : IDL.Null,
  });
  const EventUniquesChartRequestChunkParams = IDL.Record({
    'periodType' : PeriodType,
    'granularity' : EventUniquesGranularity,
    'partitionsRange' : Range,
  });
  const GetProjectEventUniques = IDL.Func(
      [AccessToken__1, QueryEventVariant, EventUniquesChartRequestChunkParams],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const LifecycleRawData = IDL.Record({
    'churnedUsersCohort' : IDL.Vec(IDL.Int32),
    'resurrectedUsers' : IDL.Vec(IDL.Int32),
    'newUsers' : IDL.Vec(IDL.Int32),
    'churnedUsers' : IDL.Vec(IDL.Int32),
    'currentUsers' : IDL.Vec(IDL.Int32),
  });
  const LifecycleChartResultData = IDL.Record({
    'intervalStartTimeSec' : IDL.Nat32,
    'rawData' : LifecycleRawData,
  });
  const GetProjectLifecycleResult = IDL.Variant({
    'ok' : LifecycleChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectLifecycleChunkWeek = IDL.Func(
      [AccessToken__1, LifecycleChartRequestChunkParams],
      [GetProjectLifecycleResult],
      ['query'],
    );
  const IsAnyProjectAnalyticsResult = IDL.Variant({
    'ok' : IDL.Bool,
    'err' : AnalyticsReducerApiError,
  });
  const IsAnyProjectAnalytics = IDL.Func(
      [AccessToken__1],
      [IsAnyProjectAnalyticsResult],
      ['query'],
    );
  const GetProjectAnyEventUniquesWeek = IDL.Func(
      [AccessToken__1, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectAnyEventUniquesMonth = IDL.Func(
      [AccessToken__1, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectEventUniquesDay = IDL.Func(
      [AccessToken__1, EventQuery, QueryPeriod],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const RetentionTypeNDay = IDL.Record({});
  const RetentionTypeNWeek = IDL.Record({});
  const RetentionTypeNMonth = IDL.Record({});
  const RetentionType = IDL.Variant({
    'nDay' : RetentionTypeNDay,
    'nWeek' : RetentionTypeNWeek,
    'nMonth' : RetentionTypeNMonth,
  });
  const RetentionChartRequestChunkParamsNew = IDL.Record({
    'periodType' : PeriodType,
    'partitionsRange' : Range,
    'retentionType' : RetentionType,
  });
  const RetentionChartResultData = IDL.Record({
    'retentionPeriods' : IDL.Vec(IDL.Nat32),
    'retention' : IDL.Vec(IDL.Vec(IDL.Int32)),
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const GetProjectRetentionResult = IDL.Variant({
    'ok' : RetentionChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectRetentionChunkNew = IDL.Func(
      [
        AccessToken__1,
        IDL.Vec(QueryEventVariant),
        IDL.Vec(QueryEventVariant),
        RetentionChartRequestChunkParamsNew,
      ],
      [GetProjectRetentionResult],
      ['query'],
    );
  const GetProjectEventUniquesWeek = IDL.Func(
      [AccessToken__1, EventQuery, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectAnyEventUniquesDay = IDL.Func(
      [AccessToken__1, QueryPeriod],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectLifecycleChunkMonth = IDL.Func(
      [AccessToken__1, LifecycleChartRequestChunkParams],
      [GetProjectLifecycleResult],
      ['query'],
    );
  const GetProjectEventNamesResult = IDL.Variant({
    'ok' : IDL.Vec(IDL.Text),
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectEventNames = IDL.Func(
      [AccessToken__1],
      [GetProjectEventNamesResult],
      ['query'],
    );
  const StickinessChartRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const StickinessChartResultData = IDL.Record({
    'chartData' : IDL.Vec(IDL.Vec(IDL.Int32)),
    'periods' : IDL.Vec(IDL.Nat32),
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const GetProjectStickinessResult = IDL.Variant({
    'ok' : StickinessChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectStickinessChunk = IDL.Func(
      [AccessToken__1, StickinessChartRequestChunkParams],
      [GetProjectStickinessResult],
      ['query'],
    );
  const FunnelStepUniques = IDL.Vec(IDL.Nat32);
  const FunnelChartResultData = IDL.Record({
    'overtime' : IDL.Vec(FunnelStepUniques),
    'classic' : FunnelStepUniques,
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const GetProjectFunnelResult = IDL.Variant({
    'ok' : FunnelChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectFunnelChunkDay = IDL.Func(
      [
        AccessToken__1,
        IDL.Vec(QueryEventVariant),
        PeriodType,
        QueryPartitionRange,
      ],
      [GetProjectFunnelResult],
      ['query'],
    );
  const GetProjectLifecycleChunkDay = IDL.Func(
      [AccessToken__1, LifecycleChartRequestChunkParams],
      [GetProjectLifecycleResult],
      ['query'],
    );
  const RetentionChartRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const GetProjectRetentionChunk = IDL.Func(
      [AccessToken__1, RetentionChartRequestChunkParams],
      [GetProjectRetentionResult],
      ['query'],
    );
  const AnalyticsReducerApi = IDL.Record({
    'getProjectDashboardChunk' : GetProjectDashboardChunk,
    'getProjectEventUniquesMonth' : GetProjectEventUniquesMonth,
    'getProjectEventUniques' : GetProjectEventUniques,
    'getProjectLifecycleChunkWeek' : GetProjectLifecycleChunkWeek,
    'isAnyProjectAnalytics' : IsAnyProjectAnalytics,
    'getProjectAnyEventUniquesWeek' : GetProjectAnyEventUniquesWeek,
    'getProjectAnyEventUniquesMonth' : GetProjectAnyEventUniquesMonth,
    'getProjectEventUniquesDay' : GetProjectEventUniquesDay,
    'getProjectRetentionChunkNew' : GetProjectRetentionChunkNew,
    'getProjectEventUniquesWeek' : GetProjectEventUniquesWeek,
    'getProjectAnyEventUniquesDay' : GetProjectAnyEventUniquesDay,
    'getProjectLifecycleChunkMonth' : GetProjectLifecycleChunkMonth,
    'getProjectEventNames' : GetProjectEventNames,
    'getProjectStickinessChunk' : GetProjectStickinessChunk,
    'getProjectFunnelChunkDay' : GetProjectFunnelChunkDay,
    'getProjectLifecycleChunkDay' : GetProjectLifecycleChunkDay,
    'getProjectRetentionChunk' : GetProjectRetentionChunk,
  });
  const GetLogMessagesFilter = IDL.Record({
    'analyzeCount' : IDL.Nat32,
    'messageRegex' : IDL.Opt(IDL.Text),
    'messageContains' : IDL.Opt(IDL.Text),
  });
  const Nanos = IDL.Nat64;
  const GetLogMessagesParameters = IDL.Record({
    'count' : IDL.Nat32,
    'filter' : IDL.Opt(GetLogMessagesFilter),
    'fromTimeNanos' : IDL.Opt(Nanos),
  });
  const GetLatestLogMessagesParameters = IDL.Record({
    'upToTimeNanos' : IDL.Opt(Nanos),
    'count' : IDL.Nat32,
    'filter' : IDL.Opt(GetLogMessagesFilter),
  });
  const CanisterLogRequest = IDL.Variant({
    'getMessagesInfo' : IDL.Null,
    'getMessages' : GetLogMessagesParameters,
    'getLatestMessages' : GetLatestLogMessagesParameters,
  });
  const CanisterLogFeature = IDL.Variant({
    'filterMessageByContains' : IDL.Null,
    'filterMessageByRegex' : IDL.Null,
  });
  const CanisterLogMessagesInfo = IDL.Record({
    'features' : IDL.Vec(IDL.Opt(CanisterLogFeature)),
    'lastTimeNanos' : IDL.Opt(Nanos),
    'count' : IDL.Nat32,
    'firstTimeNanos' : IDL.Opt(Nanos),
  });
  const LogMessagesData = IDL.Record({
    'timeNanos' : Nanos,
    'message' : IDL.Text,
  });
  const CanisterLogMessages = IDL.Record({
    'data' : IDL.Vec(LogMessagesData),
    'lastAnalyzedMessageTimeNanos' : IDL.Opt(Nanos),
  });
  const CanisterLogResponse = IDL.Variant({
    'messagesInfo' : CanisterLogMessagesInfo,
    'messages' : CanisterLogMessages,
  });
  const MetricsGranularity = IDL.Variant({
    'hourly' : IDL.Null,
    'daily' : IDL.Null,
  });
  const GetMetricsParameters__1 = IDL.Record({
    'dateToMillis' : IDL.Nat,
    'granularity' : MetricsGranularity,
    'dateFromMillis' : IDL.Nat,
  });
  const UpdateCallsAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterHeapMemoryAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterCyclesAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterMemoryAggregatedData = IDL.Vec(IDL.Nat64);
  const HourlyMetricsData = IDL.Record({
    'updateCalls' : UpdateCallsAggregatedData,
    'canisterHeapMemorySize' : CanisterHeapMemoryAggregatedData,
    'canisterCycles' : CanisterCyclesAggregatedData,
    'canisterMemorySize' : CanisterMemoryAggregatedData,
    'timeMillis' : IDL.Int,
  });
  const NumericEntity = IDL.Record({
    'avg' : IDL.Nat64,
    'max' : IDL.Nat64,
    'min' : IDL.Nat64,
    'first' : IDL.Nat64,
    'last' : IDL.Nat64,
  });
  const DailyMetricsData = IDL.Record({
    'updateCalls' : IDL.Nat64,
    'canisterHeapMemorySize' : NumericEntity,
    'canisterCycles' : NumericEntity,
    'canisterMemorySize' : NumericEntity,
    'timeMillis' : IDL.Int,
  });
  const CanisterMetricsData = IDL.Variant({
    'hourly' : IDL.Vec(HourlyMetricsData),
    'daily' : IDL.Vec(DailyMetricsData),
  });
  const CanisterMetrics__1 = IDL.Record({ 'data' : CanisterMetricsData });
  const StatusRequest = IDL.Record({
    'memory_size' : IDL.Bool,
    'cycles' : IDL.Bool,
    'heap_memory_size' : IDL.Bool,
  });
  const GetMetricsParameters = IDL.Record({
    'dateToMillis' : IDL.Nat,
    'granularity' : MetricsGranularity,
    'dateFromMillis' : IDL.Nat,
  });
  const MetricsRequest = IDL.Record({ 'parameters' : GetMetricsParameters });
  const GetInformationRequest = IDL.Record({
    'status' : IDL.Opt(StatusRequest),
    'metrics' : IDL.Opt(MetricsRequest),
    'version' : IDL.Bool,
  });
  const StatusResponse = IDL.Record({
    'memory_size' : IDL.Opt(IDL.Nat64),
    'cycles' : IDL.Opt(IDL.Nat64),
    'heap_memory_size' : IDL.Opt(IDL.Nat64),
  });
  const CanisterMetrics = IDL.Record({ 'data' : CanisterMetricsData });
  const MetricsResponse = IDL.Record({ 'metrics' : IDL.Opt(CanisterMetrics) });
  const GetInformationResponse = IDL.Record({
    'status' : IDL.Opt(StatusResponse),
    'metrics' : IDL.Opt(MetricsResponse),
    'version' : IDL.Opt(IDL.Nat),
  });
  const ProjectDashboardRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const MetricValue = IDL.Variant({ 'count' : IDL.Int, 'gauge' : IDL.Nat });
  const MetricLabel = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
  const MetricData = IDL.Record({
    'metricValue' : MetricValue,
    'labels' : IDL.Opt(IDL.Vec(MetricLabel)),
  });
  const MetricType = IDL.Variant({ 'counter' : IDL.Null, 'gauge' : IDL.Null });
  const MetricsData = IDL.Record({
    'data' : IDL.Vec(MetricData),
    'help' : IDL.Text,
    'name' : IDL.Text,
    'metricType' : MetricType,
  });
  const CollectMetricsRequestType = IDL.Variant({
    'force' : IDL.Null,
    'normal' : IDL.Null,
  });
  const UpdateInformationRequest = IDL.Record({
    'metrics' : IDL.Opt(CollectMetricsRequestType),
  });
  return IDL.Service({
    'backup_ProjectClientEventMonthActivityIndexData' : IDL.Func(
        [ProjectEventMonthDataId__1, Range],
        [BackupResultProjectClientEventMonthActivityIndex],
        ['query'],
      ),
    'backup_ProjectClientMonthActivityIndexData' : IDL.Func(
        [ProjectId__1, Range],
        [BackupResultProjectClientMonthActivityIndex],
        ['query'],
      ),
    'backup_ProjectClientProfiles' : IDL.Func(
        [ProjectId__1, Range],
        [BackupResultProjectClientProfiles],
        ['query'],
      ),
    'backup_ProjectIds' : IDL.Func([], [BackupResultProjects], ['query']),
    'backup_ProjectMonthCountersData' : IDL.Func(
        [ProjectId__1],
        [BackupResultProjectMonthCounters],
        ['query'],
      ),
    'backup_ProjectMonthRegistrationData' : IDL.Func(
        [ProjectStatsDataId],
        [BackupResultProjectMonthRegistration],
        ['query'],
      ),
    'backup_ProjectMonthUniquesData' : IDL.Func(
        [ProjectId__1],
        [BackupResultProjectMonthUniques],
        ['query'],
      ),
    'backup_RestoreProjectClientEventMonthActivityIndexData' : IDL.Func(
        [
          ProjectEventMonthDataId__1,
          IDL.Vec(ProjectClientEventMonthActivityIndex),
        ],
        [BackupRestoreResult],
        [],
      ),
    'backup_RestoreProjectClientMonthActivityIndexData' : IDL.Func(
        [IDL.Vec(ProjectClientMonthActivityIndex)],
        [BackupRestoreResult],
        [],
      ),
    'backup_RestoreProjectClientProfiles' : IDL.Func(
        [ProjectId__1, IDL.Vec(ProjectClientProfiles)],
        [BackupRestoreResult],
        [],
      ),
    'backup_RestoreProjectEvents' : IDL.Func(
        [ProjectId__1],
        [BackupRestoreResult],
        [],
      ),
    'backup_RestoreProjectMonthCountersData' : IDL.Func(
        [ProjectId__1, IDL.Vec(ProjectMonthCounters)],
        [BackupRestoreResult],
        [],
      ),
    'backup_RestoreProjectMonthRegistrationData' : IDL.Func(
        [ProjectStatsDataId, ProjectMonthRegistration],
        [BackupRestoreResult],
        [],
      ),
    'backup_RestoreProjectMonthUniquesData' : IDL.Func(
        [IDL.Vec(ProjectMonthUniques)],
        [BackupRestoreResult],
        [],
      ),
    'collect' : IDL.Func(
        [IDL.Opt(IDL.Principal), SdkVersion, AccessToken],
        [CollectResult],
        [],
      ),
    'collectCanisterMetrics' : IDL.Func([], [], []),
    'collectPacket' : IDL.Func(
        [IDL.Opt(IDL.Principal), SdkVersion, AccessToken, Packet],
        [CollectPacketResult],
        [],
      ),
    'configure' : IDL.Func(
        [IDL.Vec(AnalyticsStoreConfigurationRequest)],
        [Result],
        [],
      ),
    'getAnalyticsReceiverApi' : IDL.Func(
        [IDL.Opt(IDL.Principal), SdkVersion, AccessToken],
        [GetAnalyticsReceiverApiResult],
        ['query'],
      ),
    'getAnalyticsReceiverFactory' : IDL.Func(
        [],
        [AnalyticsReceiverFactory],
        [],
      ),
    'getAnalyticsReducerApi' : IDL.Func([], [AnalyticsReducerApi], []),
    'getCanisterLog' : IDL.Func(
        [IDL.Opt(CanisterLogRequest)],
        [IDL.Opt(CanisterLogResponse)],
        ['query'],
      ),
    'getCanisterMetrics' : IDL.Func(
        [GetMetricsParameters__1],
        [IDL.Opt(CanisterMetrics__1)],
        ['query'],
      ),
    'getCanistergeekInformation' : IDL.Func(
        [GetInformationRequest],
        [GetInformationResponse],
        ['query'],
      ),
    'getInformation' : IDL.Func([], [IDL.Text], []),
    'getMGTInformation' : IDL.Func([], [IDL.Text], []),
    'getProjectAnyEventUniquesDay' : IDL.Func(
        [AccessToken__1, QueryPeriod],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectAnyEventUniquesMonth' : IDL.Func(
        [AccessToken__1, QueryPeriod, QueryPartitionRange],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectAnyEventUniquesWeek' : IDL.Func(
        [AccessToken__1, QueryPeriod, QueryPartitionRange],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectDashboardChunk' : IDL.Func(
        [AccessToken__1, ProjectDashboardRequestChunkParams],
        [GetProjectDashboardResult],
        ['query'],
      ),
    'getProjectEventNames' : IDL.Func(
        [AccessToken__1],
        [GetProjectEventNamesResult],
        ['query'],
      ),
    'getProjectEventUniques' : IDL.Func(
        [
          AccessToken__1,
          QueryEventVariant,
          EventUniquesChartRequestChunkParams,
        ],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectEventUniquesDay' : IDL.Func(
        [AccessToken__1, EventQuery, QueryPeriod],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectEventUniquesMonth' : IDL.Func(
        [AccessToken__1, EventQuery, QueryPeriod, QueryPartitionRange],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectEventUniquesWeek' : IDL.Func(
        [AccessToken__1, EventQuery, QueryPeriod, QueryPartitionRange],
        [GetProjectEventUniquesResult],
        ['query'],
      ),
    'getProjectFunnelChunkDay' : IDL.Func(
        [
          AccessToken__1,
          IDL.Vec(QueryEventVariant),
          PeriodType,
          QueryPartitionRange,
        ],
        [GetProjectFunnelResult],
        ['query'],
      ),
    'getProjectLifecycleChunkDay' : IDL.Func(
        [AccessToken__1, LifecycleChartRequestChunkParams],
        [GetProjectLifecycleResult],
        ['query'],
      ),
    'getProjectLifecycleChunkMonth' : IDL.Func(
        [AccessToken__1, LifecycleChartRequestChunkParams],
        [GetProjectLifecycleResult],
        ['query'],
      ),
    'getProjectLifecycleChunkWeek' : IDL.Func(
        [AccessToken__1, LifecycleChartRequestChunkParams],
        [GetProjectLifecycleResult],
        ['query'],
      ),
    'getProjectRetentionChunk' : IDL.Func(
        [AccessToken__1, RetentionChartRequestChunkParams],
        [GetProjectRetentionResult],
        ['query'],
      ),
    'getProjectRetentionChunkNew' : IDL.Func(
        [
          AccessToken__1,
          IDL.Vec(QueryEventVariant),
          IDL.Vec(QueryEventVariant),
          RetentionChartRequestChunkParamsNew,
        ],
        [GetProjectRetentionResult],
        ['query'],
      ),
    'getProjectStickinessChunk' : IDL.Func(
        [AccessToken__1, StickinessChartRequestChunkParams],
        [GetProjectStickinessResult],
        ['query'],
      ),
    'getProjectStickinessChunkNew' : IDL.Func(
        [
          AccessToken__1,
          IDL.Vec(QueryEventVariant),
          IDL.Vec(QueryEventVariant),
          StickinessChartRequestChunkParams,
        ],
        [GetProjectStickinessResult],
        ['query'],
      ),
    'getRetentionInstructionCount' : IDL.Func(
        [
          AccessToken__1,
          IDL.Nat32,
          IDL.Vec(QueryEventVariant),
          IDL.Vec(QueryEventVariant),
          RetentionChartRequestChunkParamsNew,
        ],
        [IDL.Text],
        ['query'],
      ),
    'isAnyProjectAnalytics' : IDL.Func(
        [AccessToken__1],
        [IsAnyProjectAnalyticsResult],
        ['query'],
      ),
    'isCollectRequired' : IDL.Func(
        [IDL.Opt(IDL.Principal), SdkVersion, AccessToken],
        [IsCollectRequiredResult],
        ['query'],
      ),
    'metrics' : IDL.Func([IDL.Text], [IDL.Vec(MetricsData)], []),
    'registerNewClient' : IDL.Func(
        [AccessToken],
        [RegisterNewClientResult],
        [],
      ),
    'updateCanistergeekInformation' : IDL.Func(
        [UpdateInformationRequest],
        [],
        [],
      ),
    'validatePacket' : IDL.Func(
        [IDL.Opt(IDL.Principal), SdkVersion, AccessToken, Packet],
        [ValidatePacketResult],
        ['query'],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
